/** Calls to the Thicket API, using the browser's session cookie. */

export class HttpError extends Error {
  constructor(readonly status: number, readonly code: string, message: string) {
    super(message);
    this.name = 'HttpError';
  }
}

/** A request that never reached the server (offline, or the connection dropped). */
export class NetworkError extends Error {
  constructor() {
    super('No connection');
    this.name = 'NetworkError';
  }
}

export type Fetch = typeof fetch;

export async function request<T>(fetchFn: Fetch, path: string, init: RequestInit = {}): Promise<T> {
  let res: Response;
  try {
    res = await fetchFn(path, {
      ...init,
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', ...(init.headers as Record<string, string>) },
    });
  } catch {
    throw new NetworkError();
  }
  if (res.status === 204) return undefined as T;
  const body = (await res.json().catch(() => ({}))) as { error?: string; message?: string };
  if (!res.ok) throw new HttpError(res.status, body.error ?? 'error', body.message ?? `Request failed (${res.status})`);
  return body as T;
}
